import React from 'react';
import { ResolvedImg } from '../utils/imageResolver';
import './Summary.css';

const SummarySection = ({ title, content, imageUrl, imageAlt, sideText, className }) => {
    const sectionClassName = ['study-summary-section', className].filter(Boolean).join(' ');
    return (
        <section className={sectionClassName}>
            <div className="container">
                <div className="study-summary-header text-center">
                    <h2 className="mb-3">{title}</h2>
                    <p className="lead">{content}</p>
                </div>
                <div className="row text-center align-items-center">
                    {imageUrl && (
                        <div className="col-md-6">
                            <div className="summary-thumb mb-3">
                                <ResolvedImg
                                    src={imageUrl}
                                    width={500}
                                    height={300}
                                    text={title}
                                    keywords={[imageAlt]}
                                    alt={imageAlt || title || ''}
                                    className="summary-thumb-img study-summary-img"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                        </div>
                    )}
                    <div className="col-md-6">
                        <div className="study-summary-panel">
                            <p className="study-summary-text">{sideText}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SummarySection;
